<template>
  <div>
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar dense>
        <v-toolbar-title>OrbitCM App </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-app-bar-nav-icon @click="showSettings"
          ><i class="fas fa-user-cog fa-2x"></i
        ></v-app-bar-nav-icon>
      </v-toolbar>
    </v-card>
    <v-main>
      <slot class="default" name="default">Orbit Treasury</slot>
    </v-main>
    <connection-settings ref="conset"></connection-settings>
  </div>
</template>

<script>
import ConnectionSettings from "../components/ConnectionSettings";

export default {
  name: "clean-layout",
  methods: {
    showSettings() {
      this.$refs.conset.popup();
    },
  },
  components: {
    ConnectionSettings,
  },
};
</script>

<style lang="scss" scoped></style>
